// Shared dashboard i18n keys (used by Dashboard.vue).
// Wine-domain keys (e.g. wine.drinkingWindow.*, wine.bottleSingular/Plural)
// live in ./wine.ts and are reused here without duplication.

export const dashboardDict: Record<string, [en: string, th: string]> = {
  // ── Page-level ──────────────────────────────────────────
  "Dashboard.pageTitle": ["Dashboard", "แดชบอร์ด"],

  // ── Onboarding empty state ─────────────────────────────
  "Dashboard.onboarding.title":       ["Get Started with Your Wine Stock", "เริ่มต้นจัดการคลังไวน์ของคุณ"],
  "Dashboard.onboarding.subtitle":    ["Follow these simple steps to set up your collection", "ทำตามขั้นตอนง่าย ๆ เหล่านี้เพื่อตั้งค่าคอลเลกชันของคุณ"],
  "Dashboard.onboarding.step1.title": ["Set Up Locations", "ตั้งค่าตำแหน่งจัดเก็บ"],
  "Dashboard.onboarding.step1.desc":  ["Create storage locations like stock rooms, racks, and shelves", "สร้างตำแหน่งจัดเก็บ เช่น ห้องสต็อก ชั้นวาง และแร็ค"],
  "Dashboard.onboarding.step2.title": ["Add Your Wines", "เพิ่มไวน์ของคุณ"],
  "Dashboard.onboarding.step2.desc":  ["Add wines manually or scan labels with our smart import", "เพิ่มไวน์ด้วยตัวเองหรือสแกนฉลากด้วยระบบนำเข้าอัจฉริยะ"],
  "Dashboard.onboarding.step3.title": ["Create Receipts", "สร้างใบรับสินค้า"],
  "Dashboard.onboarding.step3.desc":  ["Group bottles into receipts and track purchases, costs, and suppliers", "จัดกลุ่มขวดเป็นใบรับ และติดตามการซื้อ ต้นทุน และซัพพลายเออร์"],

  // ── Card titles ────────────────────────────────────────
  "Dashboard.card.wines":        ["Wines", "ไวน์"],
  "Dashboard.card.cellarHistory": ["Cellar history", "ประวัติคลัง"],
  "Dashboard.card.auditProgress": ["Today's Audit Progress", "ความคืบหน้าการตรวจนับวันนี้"],
  "Dashboard.card.locations":    ["Locations", "ตำแหน่งจัดเก็บ"],
  "Dashboard.card.team":         ["Team", "ทีมงาน"],
  "Dashboard.card.topStyles":    ["Top styles", "สไตล์ยอดนิยม"],
  "Dashboard.card.topRegions":   ["Top regions", "แหล่งผลิตยอดนิยม"],
  "Dashboard.card.topProducers": ["Top producers", "ผู้ผลิตยอดนิยม"],
  "Dashboard.card.drinkingWindow": ["Drinking window", "ช่วงเวลาดื่ม"],

  // ── Wines stats grid (uses wine.wine for "Wines" too) ──
  "Dashboard.stat.bottles":   ["Bottles",   "ขวด"],
  "Dashboard.stat.regions":   ["Regions",   "แหล่งผลิต"],
  "Dashboard.stat.producers": ["Producers", "ผู้ผลิต"],

  // ── Locations / Team detail labels ──────────────────────
  "Dashboard.locations.subtitle": ["Storage locations", "ตำแหน่งจัดเก็บทั้งหมด"],
  "Dashboard.team.subtitle":      ["Members", "สมาชิก"],

  // ── Audit progress ─────────────────────────────────────
  "Dashboard.audit.kpi.locationsAudited": ["Locations audited", "ตำแหน่งที่ตรวจแล้ว"],
  "Dashboard.audit.kpi.scansToday":       ["Scans today",       "การสแกนวันนี้"],
  "Dashboard.audit.kpi.staffActive":      ["Staff active",      "ทีมงานที่ปฏิบัติงาน"],
  "Dashboard.audit.progressLine":         ["{done} done · {pending} pending", "{done} เสร็จ · {pending} ค้าง"],
  "Dashboard.audit.column.location": ["Location", "ตำแหน่ง"],
  "Dashboard.audit.column.scans":    ["Scans",    "การสแกน"],
  "Dashboard.audit.column.staff":    ["Staff",    "ทีมงาน"],
  "Dashboard.audit.column.status":   ["Status",   "สถานะ"],
  "Dashboard.audit.status.done":     ["Done",     "เสร็จแล้ว"],
  "Dashboard.audit.status.pending":  ["Pending",  "รอตรวจ"],

  // ── Top lists (apex chart labels) ──────────────────────
  "Dashboard.styles.unknown": ["Unknown", "ไม่ทราบ"],

  // ── Cellar history feed ────────────────────────────────
  "Dashboard.action.create":     ["Created",   "สร้าง"],
  "Dashboard.action.update":     ["Updated",   "แก้ไข"],
  "Dashboard.action.delete":     ["Deleted",   "ลบ"],
  "Dashboard.action.restore":    ["Restored",  "กู้คืน"],
  "Dashboard.action.correction": ["Corrected", "แก้ไขข้อมูล"],
  "Dashboard.action.fallback":   ["Activity",  "กิจกรรม"],

  // ── timeAgo() outputs ──────────────────────────────────
  "Dashboard.timeAgo.justNow": ["just now", "เมื่อกี้"],
  "Dashboard.timeAgo.minutes": ["{n}m ago", "{n} นาทีที่แล้ว"],
  "Dashboard.timeAgo.hours":   ["{n}h ago", "{n} ชั่วโมงที่แล้ว"],
  "Dashboard.timeAgo.days":    ["{n}d ago", "{n} วันที่แล้ว"],
};
